/** Struggling students in a circle (docs/14 B10): who meets the program's indicators, and why. */
import { z } from "zod";
export const StrugglingIndicator = z.enum(["repeats", "unfinished", "absences", "carried"]);
export const StrugglingQuery = z.object({ date: z.iso.date() });
export const StrugglingResponse = z.object({
    date: z.string(),
    /** The circle's effective rules; null while unset (nobody is flagged). */
    rules: z
        .object({ periodDays: z.number(), minIndicators: z.number(), provisional: z.boolean() })
        .nullable(),
    students: z.array(z.object({
        enrollmentId: z.uuid(),
        student: z.object({ id: z.uuid(), name: z.string() }),
        reasons: z.array(z.object({ indicator: StrugglingIndicator, value: z.number(), threshold: z.number() })),
    })),
});
/** A circle's active students with today's state, for the teacher's list and filters (FR-TCH-1). */
export const CircleStudentsQuery = z.object({ date: z.iso.date() });
export const CircleStudent = z.object({
    enrollmentId: z.uuid(),
    student: z.object({ id: z.uuid(), name: z.string() }),
    /** A result recorded today (live or in person), in the organization's time zone. */
    recitedToday: z.boolean(),
    /** Today's plan items not passed yet. */
    pendingToday: z.number(),
    /** Earlier plan items still not passed: the student is behind the plan. */
    overdue: z.number(),
    /** Meets the circle's struggling rules (B10). */
    struggling: z.boolean(),
    lastResultAt: z.string().nullable(),
});
export const CircleStudentsResponse = z.object({ date: z.string(), students: z.array(CircleStudent) });
//# sourceMappingURL=struggling.js.map